module.exports = __webpack_public_path__ + "static/img/wx.df00749.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wx.jpg
// module id = rZOy
// module chunks = 9